import {
  PAYIN_ALL,
  PAYIN_GET,
  PAYIN_DEL,
  PAYIN_PUT,
  PAYIN_POST,
  PAYIN_LOADING,
  PAYIN_ERROR,
  PAYIN_RESET,
} from '../../actions/types';

const initialState = {
  payin: null,
  isLoading: true,
  isCompleted: true,
};
// eslint-disable-next-line func-names
export default function (state = initialState, action) {
  switch (action.type) {
    case PAYIN_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case PAYIN_GET:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case PAYIN_POST:
      return { ...state, isLoading: false, isCompleted: true };
    case PAYIN_PUT: {
      const payloadId = action.payload?._id || action.payload?.id;
      return {
        ...state,
        isLoading: false,
        isCompleted: true,
        rows: state.rows && payloadId
          ? state.rows.map((r) =>
              (r._id || r.id) === payloadId ? { ...r, ...action.payload } : r,
            )
          : state.rows,
      };
    }
    case PAYIN_DEL: {
      const delId = action.payload?._id || action.payload?.id;
      return {
        ...state,
        isLoading: false,
        isCompleted: true,
        rows: state.rows && delId
          ? state.rows.filter((r) => (r._id || r.id) !== delId)
          : state.rows,
        total: state.rows && delId ? Math.max((state.total || 1) - 1, 0) : state.total,
      };
    }
    case PAYIN_RESET:
      return { PAYIN: null, isLoading: true, isCompleted: true };
    case PAYIN_LOADING:
      return { ...state, isLoading: true, isCompleted: true };
    case PAYIN_ERROR:
      return { ...state, isLoading: false, isCompleted: false };
    default:
      return state;
  }
}
